<script>
export default {
  name: 'trackeable',
  mounted: function() {
    if (!window.ga) return

    const url = '/' + location.hash;
    window.ga('set', 'page', url);
    window.ga('send', 'pageview');
    window.ga('hwonlyspa.set', 'page', url);
    window.ga('hwonlyspa.send', 'pageview');
  }
};
</script>
